import React from 'react';
import classNames from 'classnames';
import {observer} from 'mobx-react';
import {Component} from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {
    setFieldToShow,
    setOp,
    getCondZoomType,
    getCondChooseList,
    getCondSearchList
} from '../actions/Cond';
import {searchActions} from '../../../../constants/SearchActions';
import {observable, makeObservable} from 'mobx';
import TreeSelect from 'rc-tree-select';
import 'rc-tree-select/assets/index.css';
import {getGeneratorMsg, generatorMessages} from '../../../../constants/TextConst';
import SearchPanel from './SearchPanel';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {getFnsLocale, getLang} from '../../../../Localization';
import {format} from 'date-fns';

@observer
class Condition extends Component<any, any> {
    @observable selectedReport;
    @observable chooseListValues;
    @observable searchList;
    @observable searchPanelOpen;
    @observable zoomType;

    ops;
    fieldsToShow;
    reportsToShow;
    forValue;
    cursorIndex;
    startIndex;
    lastString;
    selectedSearchTypeValue;
    selectedSearchItem;
    searchItemValue;
    dateFormat: string;

    constructor(props) {
        super(props);
        makeObservable(this);
        this.ops = this.props.ops;
        this.fieldsToShow = this.props.fieldsToShow;
        this.reportsToShow = this.props.reportsToShow;
        this.forValue = this.props.forValue;
        this.chooseListValues = [];
        this.searchList = {};
        this.selectedSearchItem = {};
        this.searchItemValue = {};

        this.selectedReport = this.props.cond.fieldToShowSelected;
        this.handleOpChange = this.handleOpChange.bind(this);
        this.handleFirstInputChange = this.handleFirstInputChange.bind(this);
        this.handleSecondInputChnage = this.handleSecondInputChnage.bind(this);
        this.addNewCond = this.addNewCond.bind(this);
        this.removeCond = this.removeCond.bind(this);
        this.onTreeChange = this.onTreeChange.bind(this);
        this.setConditionValue = this.setConditionValue.bind(this);
        this.setSearchConditionValue = this.setSearchConditionValue.bind(this);
        this.setCondZoomType = this.setCondZoomType.bind(this);
        this.setCondChooseList = this.setCondChooseList.bind(this);
        this.setCondSearchList = this.setCondSearchList.bind(this);
        this.setMoreCondSearchList = this.setMoreCondSearchList.bind(this);
        this.getMoreSearchListValues = this.getMoreSearchListValues.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleIngonreCase = this.handleIngonreCase.bind(this);
        this.handleSearchFromStart = this.handleSearchFromStart.bind(this);
        this.onValuesDropDownOpen = this.onValuesDropDownOpen.bind(this);

        this.handleSearch = this.handleSearch.bind(this);

        this.searchPanelOpen = false;
        this.selectedSearchTypeValue = null;

        this.dateFormat = getLang() === '3' ? 'MM/dd/yy' : 'dd/MM/yy';

        this.state = {
            startDate: new Date(),
            datePickerFirst: false,
            datePickerSecond: false
        };
        this.handleChangeFirst = this.handleChangeFirst.bind(this);
        this.handleChangeSecond = this.handleChangeSecond.bind(this);
        this.closeDatePickers = this.closeDatePickers.bind(this);

        this.setCondZoomType(this.props.cond.zoomType, this.props.cond.width);
    }

    handleChangeFirst(date) {
        this.setState({
            startDate: date,
            datePickerFirst: false
        });
        this.setConditionValue('firstInput', null, format(date, this.dateFormat));
    }

    handleChangeSecond(date) {
        this.setState({
            startDate: date,
            datePickerSecond: false
        });
        this.setConditionValue('secondInput', null, format(date, this.dateFormat));
    }

    closeDatePickers() {
        this.setState({
            datePickerFirst: false,
            datePickerSecond: false
        });
    }

    getChildData(children) {
        const data: any = [];

        for (const key in children) {
            if (children.hasOwnProperty(key)) {
                const item = children[key];
                data.push({
                    title: item.label,
                    value: item.id + '',
                    key: item.title + key + '',
                    disabled: false
                });
            }
        }

        return data;
    }

    setConditionValue(type, fullSelectedObject, date) {
        const {cond} = this.props;
        cond[type] = fullSelectedObject ? fullSelectedObject.triggerNode.props.retval : date;
    }

    setSearchConditionValue(selectedItem, type) {
        const {cond} = this.props;
        this.selectedSearchItem[type] = selectedItem;
        cond[type] = selectedItem.selectedId;
    }

    getData() {
        const {reportsToShow} = this.props;
        const listData: any = [];

        for (const key in reportsToShow) {
            if (reportsToShow.hasOwnProperty(key)) {
                const item = reportsToShow[key];

                listData.push({
                    title: item.label,
                    value: item.id + '',
                    key: key,
                    disabled: true,
                    children: this.getChildData(item.children)
                });
            }
        }

        return listData;
    }

    handleOpChange(e) {
        const {cond} = this.props;
        for (let i = 0; i < this.ops.length; i++) {
            if (this.ops[i].id === e.target.value || this.ops[i].id === parseInt(e.target.value)) {
                setOp(cond, e.target.value, this.ops[i].numOfInputs);
                return;
            }
        }
    }

    handleFirstInputChange(e) {
        const {cond} = this.props;
        //cond.setIsFirstExprValid(false);
        cond.firstInput = e.target.value;

        if (this.selectedSearchItem) {
            this.selectedSearchItem['firstInput'] = {};
            this.selectedSearchItem['firstInput'].selectedId = e.target.value;
        }
    }

    handleSecondInputChnage(e) {
        const {cond} = this.props;
        //cond.setIsSecondExprValid(false);
        cond.secondInput = e.target.value;
        if (this.selectedSearchItem) {
            this.selectedSearchItem['secondInput'] = {};
            this.selectedSearchItem['secondInput'].selectedId = e.target.value;
        }
    }

    addNewCond() {
        const {addCond} = this.props;
        addCond();
    }

    removeCond() {
        const {removeCond, cond} = this.props;
        removeCond(cond);
    }

    onTreeChange(value, ...args) {
        this.selectedSearchItem = {};

        if (!args[1].triggerNode) {
            this.selectedReport = null;
            setFieldToShow(this.props.cond, null);
        } else if (!args[1].triggerNode.props.children.length) {
            this.chooseListValues = [];
            this.props.cond.firstInput = '';
            this.props.cond.secondInput = '';

            this.selectedReport = value;
            setFieldToShow(this.props.cond, value);
            getCondZoomType(value, this.setCondZoomType);
        }
    }

    renderConditionSelector(type) {
        switch (this.zoomType) {
            case 'search':
                return this.renderSearchSelector(type);
            case 'choose':
            case 'date':
                return this.renderValuesSelect(type);
            default:
                return null;
        }
    }

    getCondZoomData(searchAction?, searchString?) {
        switch (this.zoomType) {
            case 'search':
                getCondSearchList(
                    this.selectedReport,
                    searchAction,
                    this.cursorIndex,
                    this.startIndex,
                    this.lastString,
                    searchString ? searchString : '',
                    this.isNewDataSearchAction(searchAction)
                        ? this.setCondSearchList
                        : this.setMoreCondSearchList
                );
                break;
            case 'choose':
                getCondChooseList(this.selectedReport, this.setCondChooseList);
                return;
            case 'date':
                getCondChooseList(
                    this.selectedReport.substring(0, this.selectedReport.indexOf('.') + 1) + '-1',
                    this.setCondChooseList,
                    this.selectedReport.substring(this.selectedReport.indexOf('.') + 1)
                );
                return;
            case 'none':
                break;
            default:
                break;
        }
    }

    isNewDataSearchAction(searchAction) {
        switch (searchAction) {
            case searchActions.NEXT:
                return false;
            default:
                return true;
        }
    }

    setCondZoomType(type, width) {
        this.props.cond.zoomType = type;
        this.props.cond.width = width;
        this.zoomType = type;
        if (this.zoomType === 'search') {
            this.cursorIndex = 0;
            this.startIndex = 0;
            this.lastString = '';
        }
    }

    setCondSearchList(searchList) {
        this.cursorIndex = searchList.cursorIndex;
        this.startIndex = searchList.startIndex;
        this.lastString = searchList.lastString;
        this.searchPanelOpen = true;
        this.searchList = searchList;
    }

    setMoreCondSearchList(searchList) {
        this.cursorIndex = searchList.cursorIndex;
        this.startIndex = searchList.startIndex;

        this.selectedSearchItem = {};

        const {searchLine} = this.searchList;

        if (this.lastString !== searchList.lastString) {
            this.lastString = searchList.lastString;
            const newSearchLine = searchLine.concat(searchList.searchLine);
            this.searchList = {
                ...searchList,
                searchLine: newSearchLine
            };
        }
    }

    setCondChooseList(chooseList) {
        const listValues: any = [];
        if (chooseList) {
            const listItems = chooseList.chooseLine;
            for (const key in listItems) {
                if (listItems.hasOwnProperty(key)) {
                    const item = listItems[key];
                    listValues.push(item);
                }
            }
        }

        this.chooseListValues = listValues;

        const data = this.chooseListValues;
        const listData: any = [];
        data.forEach((item, index) => {
            const secondTitle = item.head2 ? `- ${item.head2}` : '';
            listData.push({
                title: `${item.head1} ${secondTitle}`,
                value: `${item.head1} ${secondTitle}`,
                retval: item.retval,
                key: index
            });
        });

        this.setState({treeData: listData});
    }

    handleSearch(searchString, type) {
        this.searchItemValue[type] = searchString;
        this.selectedSearchItem[type] = {};
        this.lastString = '';
        this.getCondZoomData(searchActions.TEXTCHANGE, searchString);
    }

    handleTypeChange() {
        this.lastString = '';
        this.getCondZoomData(searchActions.TYPECHANGE);
    }

    getMoreSearchListValues(searchString) {
        this.getCondZoomData(searchActions.NEXT, searchString);
    }

    handleSearchFromStart(searchString) {
        this.getCondZoomData(searchActions.STARTCHANGE, searchString);
    }

    handleIngonreCase(searchString) {
        this.getCondZoomData(searchActions.IGNORECASECHANGE, searchString);
    }

    onDropDownOpen() {
        // This should be only a temporary workaround for scrollbar opens on bottom issue.
        setTimeout(() => {
            const treeDropDown = document.getElementsByClassName('rc-tree-select-dropdown')[0];
            if (treeDropDown) {
                treeDropDown.scrollTop = 0;
            }
        }, 100);
    }

    onValuesDropDownOpen(event) {
        this.onDropDownOpen();
        if (event) this.getCondZoomData();
    }

    renderValuesTreeSelect() {
        return (
            <div className="tree-select">
                <TreeSelect
                    className="condition-tree"
                    dropdownClassName="condition-tree-dropdown"
                    style={{width: 150}}
                    transitionName="rc-tree-select-dropdown-slide-up"
                    choiceTransitionName="rc-tree-select-selection__choice-zoom"
                    dropdownStyle={{maxHeight: 200, overflow: 'auto'}}
                    placeholder={<i>{getGeneratorMsg(generatorMessages.valueMsgText)}</i>}
                    searchPlaceholder={getGeneratorMsg(generatorMessages.searchMsgText)}
                    showSearch
                    allowClear
                    treeLine
                    onDropdownVisibleChange={this.onDropDownOpen}
                    treeDefaultExpandAll={false}
                    value={this.props.cond.fieldToShowSelected}
                    treeData={this.getData()}
                    treeNodeFilterProp="title"
                    filterTreeNode={false}
                    onChange={this.onTreeChange}
                />
            </div>
        );
    }

    renderConditionSelect() {
        const {ops, cond} = this.props;

        if (!this.selectedReport) {
            return null;
        }

        return (
            <select className="select op" value={cond.opSelected} onChange={this.handleOpChange}>
                {ops.map((op, id) => {
                    return (
                        <option key={op.id} value={op.id}>
                            {op.title}
                        </option>
                    );
                })}
            </select>
        );
    }

    renderActionButtons() {
        const {addCond, removeCond} = this.props;

        return (
            <div className="images">
                {addCond && (
                    <Icon icon={PriorityIcon.newAdd} skin="primary" onClick={this.addNewCond} />
                )}
                {removeCond && (
                    <Icon icon={PriorityIcon.x} skin="primary" onClick={this.removeCond} />
                )}
            </div>
        );
    }

    renderConditionValues() {
        const {cond} = this.props;

        if (!this.selectedReport) {
            return null;
        }

        const fromValueClasses = classNames('input', 'first', {
            visible: cond && cond.showFirstInput
        });
        const toValueClasses = classNames('input', 'second', {
            visible: cond && cond.showSecondInput
        });

        const readOnlyInput = false;
        /*if (this.zoomType && ["search","choose"].indexOf(this.zoomType) > -1) {
			readOnlyInput = true;
		}*/

        const toValueInputClasses = classNames('input-text', {
            visible: cond && cond.showSecondInput
        });
        const fromValueInputClass = classNames('input-text', {
            visible: cond && cond.showFirstInput
        });

        return (
            <div className="range-input-wrapper">
                <div className={fromValueClasses}>
                    <input
                        onChange={this.handleFirstInputChange}
                        className={fromValueInputClass}
                        type="text"
                        readOnly={readOnlyInput}
                        title={cond.firstInput}
                        value={cond.firstInput}
                    />
                    {this.renderConditionSelector('firstInput')}
                    {this.state.datePickerFirst && this.renderDatePicker(this.handleChangeFirst)}
                </div>
                <div className={toValueClasses}>
                    <input
                        onChange={this.handleSecondInputChnage}
                        className={toValueInputClasses}
                        type="text"
                        readOnly={readOnlyInput}
                        title={cond.secondInput}
                        value={cond.secondInput}
                    />
                    {this.renderConditionSelector('secondInput')}
                    {this.state.datePickerSecond && this.renderDatePicker(this.handleChangeSecond)}
                </div>
            </div>
        );
    }

    renderSearchSelector(type) {
        const {cond} = this.props;
        const searchString = type === 'firstInput' ? cond.firstInput : cond.secondInput;

        return (
            <div
                className="triangle"
                onClick={() => {
                    this.selectedSearchTypeValue = type;

                    if (!this.searchList.searchLine || this.searchList.searchLine.length === 0) {
                        this.getCondZoomData(searchActions.START, searchString);
                    } else {
                        this.searchPanelOpen = true;
                    }
                }}
            />
        );
    }

    renderDatePicker(handleChange) {
        return (
            <DatePicker
                selected={this.state.startDate}
                onChange={handleChange}
                inline //todayButton={"Today"}
                dateFormat={this.dateFormat}
                onClickOutside={this.closeDatePickers}
                locale={getFnsLocale(getLang())}
            />
        );
    }

    renderValuesSelect(type) {
        const data = this.chooseListValues;
        const listData: any = [];
        data.forEach((item, index) => {
            const secondTitle = item.head2 ? `- ${item.head2}` : '';

            listData.push({
                title: `${item.head1} ${secondTitle}`,
                value: `${item.head1} ${secondTitle}`,
                retval: item.retval,
                key: index
            });
        });

        return (
            <div className="condition-value-select">
                <TreeSelect
                    className="condition-values-tree"
                    dropdownClassName="condition-tree-dropdown"
                    transitionName="rc-tree-select-dropdown-slide-up"
                    choiceTransitionName="rc-tree-select-selection__choice-zoom"
                    dropdownStyle={{maxHeight: 200, overflow: 'auto'}}
                    placeholder={
                        <div
                            onContextMenu={e => {
                                e.preventDefault();
                                if (this.zoomType === 'date') {
                                    if (type === 'firstInput')
                                        this.setState({datePickerFirst: true});
                                    else this.setState({datePickerSecond: true});
                                }
                            }}
                            className="triangle"
                        />
                    }
                    value={null}
                    onDropdownVisibleChange={this.onValuesDropDownOpen}
                    showSearch
                    allowClear
                    treeLine
                    treeDefaultExpandAll={false}
                    treeData={listData}
                    onChange={(value, selectedObject, fullObject) => {
                        this.setConditionValue(type, fullObject, null);
                    }}
                />
            </div>
        );
    }

    render() {
        const {cond} = this.props;
        const type = this.selectedSearchTypeValue;

        const condClassNames = classNames('cond', {
            one: cond.showFirstInput && !cond.showSecondInput,
            two: cond.showSecondInput
        });

        return (
            <div className={condClassNames}>
                {this.renderValuesTreeSelect()}
                {this.renderConditionSelect()}
                {this.renderConditionValues()}
                {this.renderActionButtons()}
                {this.searchPanelOpen && (
                    <SearchPanel
                        selectedSearchItem={this.selectedSearchItem[type]}
                        searchItemValue={this.searchItemValue[type]}
                        handleSelect={this.setSearchConditionValue}
                        condValue={type}
                        handleTypeChange={this.handleTypeChange}
                        searchList={this.searchList}
                        handleScroll={this.getMoreSearchListValues}
                        handleClose={() => {
                            this.searchPanelOpen = false;
                        }}
                        handleSearch={this.handleSearch}
                        handleSearchFromStart={this.handleSearchFromStart}
                        handleIngonreCase={this.handleIngonreCase}
                    />
                )}
            </div>
        );
    }
}

export default Condition;
